import { Box, Flex, Text } from "@chakra-ui/react";
import YoYChip from "./YoYChip";

// Fluid big-number primitive shared across the Insights dashboards. The font
// size is fluid: clamp() picks the largest value that fits the card's share
// of the viewport, so the number scales with screen width and never wraps
// onto a second line.
// Do NOT replace the var(--big) clamp with a static fontSize token (e.g.
// heading.2xl) — that's the regression the user has reverted multiple times.
//
// `pctChange` renders the YoY chip flush right of the number so the
// directional indicator stays adjacent to the figure it qualifies. Pass
// null/undefined to suppress the chip.
//
// Mirrors the local BigNumber in SummaryCards.jsx (the carbon side keeps its
// own copy untouched); extracted here so the supplier dashboard can reuse it.
const BigNumber = ({ children, color = "gray.800", pctChange = null }) => (
  <Box display="inline-block" whiteSpace="nowrap" sx={{ "--big": "clamp(20px, 2.6vw, 48px)" }}>
    <Flex align="center" gap={2}>
      <Text
        fontSize="var(--big)"
        fontWeight="bold"
        color={color}
        lineHeight="1"
        letterSpacing="-0.02em"
      >
        {children}
      </Text>
      {pctChange != null && <YoYChip pctChange={pctChange} />}
    </Flex>
  </Box>
);

// ESG-3961: getYoYChange used to be defined and exported here, with a byte-identical private copy in
// SummaryCards.jsx. It now lives in utils/yoy.js so it can be unit-tested — import it from there.

export default BigNumber;
